<template>
  <body>
    <div class="myPost_wrapper coupon_wrapper">
      <!-- title -->
      <div class="main_top">
        <h1><img src ="images/basic/icon/back.svg" onclick="history.back()" class="back">
          쿠폰
          <div class="coupon_shop">
            <img src="images/basic/icon/shopping20.svg" alt="">
          </div>
          <div class="trash">
            <img src="images/basic/icon/trash18.svg" alt="">
          </div>
        </h1>
        
      </div>
      <div class="div_padding"></div>
      <div class="ul_menu_div">
        <ul class="menu_ul">
          <li id="best" @click="coupon_menu(1);" :class="num == 1 ? 'active' : ''">미사용 쿠폰</li>
          <li id="coin" @click="coupon_menu(2);" :class="num == 2 ? 'active' : ''">사용완료 쿠폰</li>
        </ul>
      </div>
      <!-- coupon list -->
      <div class="list_div" id="coupon_list">

        <div onclick="location_coupon_detail();" class="post_list">
          <div class="coupon_option">
            <p>베스킨라빈스 스트로베리움타타</p>
            <p class="code">1826 8172 8376 <img src="images/basic/icon/copy.svg"> </p>
            <p>유효기간 없음</p>
          </div>
          <div class="coupon_img">
            <img src="images/basic/img/coupon-item1.png" alt="">
          </div>
        </div>


        <div class="post_list">
          <div class="coupon_option">
            <p>베스킨라빈스 스트로베리움타타</p>
            <p class="code">1826 8172 8376 <img src="images/basic/icon/copy.svg"> </p>
            <p>유효기간 없음</p>
          </div>
          <div class="coupon_img">
            <img src="images/basic/img/coupon-item1.png" alt="">
          </div>
        </div>
        <div class="post_list">
          <div class="coupon_option">
            <p>베스킨라빈스 스트로베리움타타</p>
            <p class="code">1826 8172 8376 <img src="images/basic/icon/copy.svg"> </p>
            <p>유효기간 없음</p>
          </div>
          <div class="coupon_img">
            <img src="images/basic/img/coupon-item1.png" alt="">
          </div>
        </div>
        <div class="post_list">
          <div class="coupon_option">
            <p>베스킨라빈스 스트로베리움타타</p>
            <p class="code">1826 8172 8376 <img src="images/basic/icon/copy.svg"> </p>
            <p>유효기간 없음</p>
          </div>
          <div class="coupon_img">
            <img src="images/basic/img/coupon-item1.png" alt="">
          </div>
        </div>
        <div class="post_list">
          <div class="coupon_option">
            <p>베스킨라빈스 스트로베리움타타</p>
            <p class="code">1826 8172 8376 <img src="images/basic/icon/copy.svg"> </p>
            <p>유효기간 없음</p>
          </div>
          <div class="coupon_img">
            <img src="images/basic/img/coupon-item1.png" alt="">
          </div>
        </div>
        <div class="post_list">
          <div class="coupon_option">
            <p>베스킨라빈스 스트로베리움타타</p>
            <p class="code">1826 8172 8376 <img src="images/basic/icon/copy.svg"> </p>
            <p>유효기간 없음</p>
          </div>
          <div class="coupon_img">
            <img src="images/basic/img/coupon-item1.png" alt="">
          </div>
        </div>
        <div class="post_list">
          <div class="coupon_option">
            <p>베스킨라빈스 스트로베리움타타</p>
            <p class="code">1826 8172 8376 <img src="images/basic/icon/copy.svg"> </p>
            <p>유효기간 없음</p>
          </div>
          <div class="coupon_img">
            <img src="images/basic/img/coupon-item1.png" alt="">
          </div>
        </div>
      </div>


      <!-- used coupon list -->
      <div class="list_div" id="used_coupon_list">

        <div class="post_list">
          <div class="check_div" style="background-image:url('images/basic/input/checkbox.svg')">
            <input type="checkbox" name="coupon_chk" style="display:none;" value="">
          </div>
          <div class="coupon_option">
            <p>베스킨라빈스 스트로베리움타타</p>
            <p class="code">1826 8172 8376 </p>
            <p>유효기간 없음</p>
          </div>
          <div class="coupon_img">
            <img src="images/basic/img/coupon-item1.png" alt="">
          </div>
        </div>

        <div class="post_list">
          <div class="check_div" style="background-image:url('images/basic/input/checkbox.svg')">
            <input type="checkbox" name="coupon_chk" style="display:none;" value="">
          </div>
          <div class="coupon_option">
            <p>베스킨라빈스 스트로베리움타타</p>
            <p class="code">1826 8172 8376 </p>
            <p>유효기간 없음</p>
          </div>
          <div class="coupon_img">
            <img src="images/basic/img/coupon-item1.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  data() {
    return {
      num: 1
    }
  },
  mounted() {
      window.$('.coupon_shop').css('display', 'inline-block');
      window.$('.trash').css('display', '');
      window.$('.check_div').click(function(){
        if(!window.$(this).find('input[type=checkbox]').attr('checked')){
          window.$(this).css("background-image", "url('images/basic/input/checkbox-checked.svg')");
          window.$(this).find('input[type=checkbox]').attr('checked', true);
        }else if(window.$(this).find('input[type=checkbox]').attr('checked')){
          window.$(this).css("background-image", "url('images/basic/input/checkbox.svg')");
          window.$(this).find('input[type=checkbox]').attr('checked', false);
        }
      })
  },
  methods: {
    coupon_menu(num){
      if(num == 1){
        window.$('.coupon_shop').css('display', 'inline-block');
        window.$('.trash').css('display', '');
        this.num = 1;
      }else if(num == 2){
        window.$('.trash').css('display', 'inline-block');
        window.$('.coupon_shop').css('display', '');
        this.num = 2;
      }
    }
  },
}
</script>

<style>

</style>